import React, { useEffect, useState } from "react";
import { Card, Form, Table } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { isEmpty } from "lodash";

import { updateRevisedProjectProfile } from "../../../../redux/slices/certify/projectsSlice";

const ProjectInfomation = () => {
  const dispatch = useDispatch();

  const { inputLoading, project, programs, mainProjects } = useSelector(
    (state) => ({
      inputLoading: state.certifyReducer.inputLoading,
      project: state.certifyReducer.project.data,
      programs: state.utilsReducer.dropdownItems.programs,
      mainProjects: state.utilsReducer.dropdownItems.mainProjects,
    }),
  );

  const [programOptions, setProgramOptions] = useState([]);
  const [mainProjectOptions, setMainProjectOptions] = useState([]);

  const [programValue, setProgramValue] = useState(null);
  const [mainProjectValue, setMainProjectValue] = useState(null);
  const [subProjectCodeValue, setSubProjectCodeValue] = useState("");

  const handleUpdateOnAction = async (value) => {
    const params = {
      project_id: project.uuid,
      program_id: programValue?.id || null,
      main_project_id: mainProjectValue?.id || null,
      code: subProjectCodeValue,
    };
    dispatch(updateRevisedProjectProfile(params));
  };

  useEffect(() => {
    if (isEmpty(project)) return;
    const filteredPrograms = programs?.filter(
      (obj) => obj.ministry_code.toString() === project.ministry_id.toString(),
    );
    setProgramOptions(filteredPrograms);

    const filteredMainProjects = mainProjects?.filter(
      (obj) =>
        obj?.ministry_id?.toString() === project?.ministry_id?.toString(),
    );
    setMainProjectOptions(filteredMainProjects);

    setProgramValue(project.program);
    setMainProjectValue(project.main_project);
    setSubProjectCodeValue(project.code);
  }, [project, programs, mainProjects]);

  return (
    <Card className='mb-3'>
      <Card.Body>
        <div className='table-responsive'>
          <Table bordered size='sm' style={{ width: "100%" }}>
            <tbody>
              <tr className='custom-table-head'>
                <th colSpan={2} className='text-uppercase ps-3'>
                  Maklumat Projek
                </th>
              </tr>
              <tr>
                <th className='ps-3' style={{ width: "20%" }}>
                  Program
                </th>
                <td>
                  <Select
                    isSearchable
                    placeholder='Pilih Program'
                    isDisabled={inputLoading}
                    options={programOptions}
                    value={programValue}
                    onChange={(value) => setProgramValue(value)}
                    noOptionsMessage={() => "Tiada pilihan"}
                    components={{
                      IndicatorSeparator: () => null,
                    }}
                    menuPortalTarget={document.body}
                    styles={{
                      control: (baseStyles, state) => ({
                        ...baseStyles,
                        borderColor: "#ced4da",
                        backgroundColor: state.isDisabled ? "#e2e8ee" : "#FFF",
                      }),
                      singleValue: (baseStyles, state) => ({
                        ...baseStyles,
                        color: state.isDisabled ? "rgb(84, 84, 84)" : "#495057", // Change text color to black when disabled
                      }),
                      placeholder: (baseStyles, state) => ({
                        ...baseStyles,
                        color: state.isDisabled ? "rgb(84, 84, 84)" : "#495057", // Change placeholder color to black when disabled
                      }),
                      menuPortal: (base) => ({
                        ...base,
                        zIndex: 9999, // bring to front
                      }),
                    }}
                    onBlur={async () => {
                      handleUpdateOnAction();
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.target.blur();
                      }
                      return;
                    }}
                  />
                </td>
              </tr>
              <tr>
                <th className='ps-3' style={{ width: "20%" }}>
                  Projek Utama
                </th>
                <td>
                  <Select
                    isSearchable
                    placeholder='Pilih Projek Utama'
                    isDisabled={inputLoading}
                    options={mainProjectOptions}
                    value={mainProjectValue}
                    onChange={(value) => setMainProjectValue(value)}
                    noOptionsMessage={() => "Tiada pilihan"}
                    components={{
                      IndicatorSeparator: () => null,
                    }}
                    menuPortalTarget={document.body}
                    styles={{
                      control: (baseStyles, state) => ({
                        ...baseStyles,
                        borderColor: "#ced4da",
                        backgroundColor: state.isDisabled ? "#e2e8ee" : "#FFF",
                      }),
                      singleValue: (baseStyles, state) => ({
                        ...baseStyles,
                        color: state.isDisabled ? "rgb(84, 84, 84)" : "#495057", // Change text color to black when disabled
                      }),
                      placeholder: (baseStyles, state) => ({
                        ...baseStyles,
                        color: state.isDisabled ? "rgb(84, 84, 84)" : "#495057", // Change placeholder color to black when disabled
                      }),
                      menuPortal: (base) => ({
                        ...base,
                        zIndex: 9999, // bring to front
                      }),
                    }}
                    onBlur={async () => {
                      handleUpdateOnAction();
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.target.blur();
                      }
                      return;
                    }}
                  />
                </td>
              </tr>
              <tr>
                <th className='ps-3' style={{ width: "20%" }}>
                  Kod Sub Projek
                </th>
                <td>
                  <Form.Group className='w-100'>
                    <Form.Control
                      name='name'
                      type='text'
                      autoComplete='off'
                      disabled={inputLoading}
                      value={subProjectCodeValue}
                      onChange={(e) => {
                        const value = e.target.value;
                        setSubProjectCodeValue(value);
                      }}
                      onBlur={async () => {
                        handleUpdateOnAction();
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.target.blur();
                        }
                        return;
                      }}
                    />
                  </Form.Group>
                </td>
              </tr>

              <tr>
                <th className='ps-3' style={{ width: "20%" }}>
                  Kementerian
                </th>
                <td>{project?.ministry?.name}</td>
              </tr>

              <tr>
                <th className='ps-3'>Jabatan</th>
                <td>{project?.department?.name || "-"}</td>
              </tr>

              <tr>
                <th className='ps-3'>Nama Projek</th>
                <td>{project?.name}</td>
              </tr>

              <tr>
                <th className='ps-3'>Keterangan Projek</th>
                <td>{project?.description}</td>
              </tr>
            </tbody>
          </Table>
        </div>
      </Card.Body>
    </Card>
  );
};

export default ProjectInfomation;
